<template>
  <div>
    <h1 class="help-title">{{ title }}</h1>
    <p class="help-description" v-if="descripcion">{{ descripcion }}</p>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    descripcion: String
  }
};
</script>

<style scoped>
.help-title {
  background-image: url(../../assets/img/promotions.svg);
  background-size: 24px;
  background-position: left center;
  background-repeat: no-repeat;
  padding-left: 35px;
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
}
.help-description {
  padding-left: 35px;
  font-size: 15px;
  line-height: 26px;
  font-family: BentonSansBBVA-Book, Helvetica, Arial, sans-serif;
}
</style>
